import React from 'react';

export const DefaultPanel = () => {
    return (
        <div className="right-side-content">
            <div className="sideContent contentBox">
              <div className="sideContentHeader">Unify Your Software and Simplify Your Workflow</div>
              <div>
                With over 800 distributor customers,
                commonsku's Connected Workflow platform transforms how you streamline operations,
                deliver exceptional customer experiences, and maintain project visibility.
                <br />
                <br />
                See how at <a href="https://www.commonsku.com">commonsku.com</a>
              </div>
            </div>
        </div>
    );
}
